// CORE
import React from "react";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";

// USER DEFINED
import Routes from "Routes/Route";
import Sidebar from "./Commons/Sidebar/Sidebar";
import Header from "./Commons/Header/Header";
import ErrorBoundary from "./Commons/ErrorBoundary";

//STYLES
import { RightContentWrapper, ContentWrapper, LayoutStyled } from "./Website.style";

function Website(props) {
	const isLoggedIn = useSelector((state) => state.Auth.isLoggedIn);
	// Resetting on pathname means a crashed screen recovers as soon as the user
	// navigates elsewhere, instead of staying stuck on the error state.
	const location = useLocation();
	const routeKey = location?.pathname;
	return (
		<React.Fragment>
			<LayoutStyled>
				{isLoggedIn ? (
					<LoggedInComponents routeKey={routeKey} />
				) : (
					<ErrorBoundary resetKey={routeKey}>
						<Routes />
					</ErrorBoundary>
				)}
			</LayoutStyled>
		</React.Fragment>
	);
}

function LoggedInComponents(props) {
	return (
		<>
			<Sidebar />
			<RightContentWrapper isLoggedIn={true}>
				<Header />
				<ContentWrapper isLoggedIn={true}>
					<ErrorBoundary resetKey={props.routeKey}>
						<Routes />
					</ErrorBoundary>
				</ContentWrapper>
			</RightContentWrapper>
		</>
	);
}

export default Website;
